var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3h12v3h3v11h-4v-5H7v5H3V6h3zm1 3h10V4H7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17h6v1H9zM6 16h1v5H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20h12v1H6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16h1v5h-1z"
  })));
};
export default SvgPrinter;